<template>
  <div :class="`m-portal m-portal-${routeType}-detail ${currentModule}`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-information">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-new-nav></portal-new-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>朱子文化</span>
                <span>&nbsp;>&nbsp;</span>
                <span>{{title[$route.params._field]}}</span>
                <!-- <span>></span>
                <span>南平市朱子文化研究会召开成立大会</span>-->
              </div>
              <div class="article">
                <!-- {{$route.params._id}} -->

                <bs-detail
                  :filter="filter"
                  :meta="meta"
                  @on-data-after="handleTitle"
                  ref="refId"
                  content-class
                >
                  <template slot="data" slot-scope="slot">
                    <h1 v-text="slot.data.title"></h1>
                    <h4><span v-show="slot.data.pushDate">发布时间：{{slot.data.pushDate}}</span><span v-show="slot.data.fromSource">（来源：{{slot.data.fromSource}}）</span></h4>
                    <h4 v-show="slot.data.author">作者：{{slot.data.author}}</h4>
                    <content style="line-height:21px;letter-spacing:2px;" v-html="slot.data.content"></content>
                  </template>
                  <template slot="empty">
                    <div class="list-none">
                      <ul></ul>
                    </div>
                  </template>
                </bs-detail>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <portal-footer></portal-footer>
  </div>
</template>
<style lange="sass" scoped>
</style>
<script>
require("../../styles/portal/information.scss");
export default {
  data() {
    return {
      top: "",
      title: {
        brower_detail: "文化资讯",
        xwzx_detail: "活动新闻",
        hdgg_detail: "公告通知",
        llyj_detail: "理论研究",
        dwjl_detail: "对外交流"
      },
      routeType: "new",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        newId: this.$route.params._newId
      },
      api: null
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNewNav: () => import("./portal-new-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    handleGoBack() {},
    handleTitle(res) {
        this.$menuFn.setTitle(
          res.data.title+"-"+this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
        );
    }
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  created() {
    this.$menuFn.setTitle(
      this.top+"-"+this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
    );
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-new-detail") {
        this.$menuFn.setTitle(
          this.top+"-"+this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
        );
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "detail",
        "portal",
        true
      );
      if (this.routeWatch && contains && this.$route.params._newId) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.newId = this.$route.params._newId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>